export const replaceSubstring = (
  value: string,
  oldSubstring: string,
  newSubstring: string
): string => value.replaceAll(oldSubstring, newSubstring);
